"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _color = _interopRequireDefault(require("../../Components/styles/color"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useFeedbackStates3 = _interopRequireDefault(require("../helper/useFeedbackStates"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-mvnwwe-0"
})(["display:flex;position:relative;background-color:", ";box-shadow:inset 0px -1px 0px ", ";user-select:none;align-items:center;cursor:pointer;:hover{box-shadow:", ";z-index:5;}"], function (props) {
  return props.backgroundColor;
}, _color["default"].grey200, function (props) {
  return props.isFolderHover ? "0px 0px 0px ".concat(_color["default"].lightPrimary, ", 0px 0px 16px rgba(39, 43, 52, 0.08)") : '';
});
var ColumnContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnContainer",
  componentId: "sc-mvnwwe-1"
})(["display:flex;flex:", ";min-width:100px;height:100%;align-items:center;", ""], function (props) {
  return props.flex;
}, function (props) {
  return props.stickyLastColumn ? "\n    @media (max-width: 760px) {\n      :last-child {\n        top: 0;\n        right: 0;\n        position: sticky;\n        background-color: white;\n        box-shadow: -3px 0px 4px rgba(0, 0, 0, 0.04), inset 0px -1px 0px #D8D8D8;\n      }\n    }\n  " : '';
});
var ListRow = function ListRow(_ref) {
  var testID = _ref.testID,
    columnRatios = _ref.columnRatios,
    children = _ref.children,
    onClick = _ref.onClick,
    customBackgroundColor = _ref.customBackgroundColor,
    isFolderHover = _ref.isFolderHover,
    stickyLastColumn = _ref.stickyLastColumn;
  var containerRef = (0, _react.useRef)(null);
  var _useFeedbackStates = (0, _useFeedbackStates3["default"])(containerRef),
    _useFeedbackStates2 = _slicedToArray(_useFeedbackStates, 2),
    isHover = _useFeedbackStates2[0],
    isPressed = _useFeedbackStates2[1];
  var getBackgroundColor = function getBackgroundColor() {
    if (onClick) {
      return isPressed ? _color["default"].grey200 : isHover ? _color["default"].grey50 : _color["default"].white;
    }
    return customBackgroundColor || _color["default"].white;
  };
  /**
   * {isFolderHover} special case for when we handle folder list items to have a hover
   */
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-cy": testID,
    isFolderHover: isFolderHover,
    ref: containerRef,
    backgroundColor: getBackgroundColor(),
    onClick: onClick
  }, children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(ColumnContainer, {
      key: index,
      flex: columnRatios[index],
      stickyLastColumn: stickyLastColumn
    }, child);
  }));
};
__signature__(ListRow, "useRef{containerRef}\nuseFeedbackStates{[isHover, isPressed]}", function () {
  return [_useFeedbackStates3["default"]];
});
ListRow.defaultProps = {
  columnRatios: [1, 1]
};
var _default = ListRow;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListRow.js");
  reactHotLoader.register(ColumnContainer, "ColumnContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListRow.js");
  reactHotLoader.register(ListRow, "ListRow", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListRow.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListRow.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();